const teamMembersStatusSelector = (teamId: string) => (
    state: sage.state.IRedux
): sage.status.Fetch => {
    return state.teams.teamMembersLookupStatus[teamId] || "none";
};

export default teamMembersStatusSelector;
